import { useEffect, useState } from "react";
import { getExecutiveDashboardData } from "../../../api/executiveDashboardService";

export default function ExecutiveDashboardPage() {
    const [data, setData] = useState({
        activeShipments: 0,
        activeOrders: 0,
        deliveredToday: 0,
        iotDevices: 0,
        onlineDevices: 0,
        blockchainEvents: 0,
        averageTrustScore: 0,
        aiRisk: 0,
        revenueToday: 0,
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            setLoading(true);

            try {
                const result = await getExecutiveDashboardData();
                setData(result);
            } catch (err) {
                console.error("Executive dashboard failed", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    return (
        <div style={{ padding: 20 }}>
            <h2>Executive Dashboard</h2>

            <p style={{ color: "#666" }}>
                Strategic logistics, blockchain, IoT and AI overview for management.
            </p>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))",
                    gap: 20,
                    marginTop: 20,
                }}
            >
                <Kpi title="Active Shipments" value={data.activeShipments} color="#1976D2" loading={loading} />
                <Kpi title="Active Orders" value={data.activeOrders} color="#43A047" loading={loading} />
                <Kpi title="Delivered Today" value={data.deliveredToday} color="#00897B" loading={loading} />
                <Kpi title="IoT Online" value={`${data.onlineDevices}/${data.iotDevices}`} color="#7B1FA2" loading={loading} />
                <Kpi title="Blockchain Events" value={data.blockchainEvents} color="#546E7A" loading={loading} />
                <Kpi title="Average Trust Score" value={`${data.averageTrustScore}%`} color="#2E7D32" loading={loading} />
                <Kpi title="AI Risk" value={`${data.aiRisk}%`} color="#C62828" loading={loading} />
                <Kpi title="Revenue Today" value={`�${data.revenueToday}`} color="#EF6C00" loading={loading} />
            </div>

            <div style={summaryStyle}>
                <h3>Executive Summary</h3>

                <p>
                    The platform combines secure logistics monitoring, blockchain-based audit,
                    IoT telemetry, digital twin tracking, smart contracts and AI-driven prediction.
                </p>

                <p>
                    Current operational status:{" "}
                    <b style={{ color: data.aiRisk <= 10 ? "green" : "red" }}>
                        {data.aiRisk <= 10 ? "Stable" : "Risk Attention Required"}
                    </b>
                </p>
            </div>
        </div>
    );
}

function Kpi({ title, value, color, loading }) {
    return (
        <div
            style={{
                background: "white",
                borderRadius: 14,
                padding: 20,
                borderTop: `6px solid ${color}`,
                boxShadow: "0 4px 12px rgba(0,0,0,.1)",
            }}
        >
            <div style={{ color: "#666", fontSize: 14 }}>{title}</div>

            <div
                style={{
                    fontSize: 34,
                    fontWeight: "bold",
                    marginTop: 12,
                }}
            >
                {loading ? "..." : value}
            </div>
        </div>
    );
}

const summaryStyle = {
    marginTop: 24,
    background: "white",
    borderRadius: 14,
    padding: 20,
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
};